export var StreamingCommandType;
(function (StreamingCommandType) {
    StreamingCommandType["RecorderStopped"] = "RecorderStopped";
    StreamingCommandType["ReceiverStopped"] = "ReceiverStopped";
    StreamingCommandType["RecorderDisconnected"] = "RecorderDisconnected";
    StreamingCommandType["SyncBlock"] = "SyncBlock";
    StreamingCommandType["SyncPacket"] = "SyncPacket";
})(StreamingCommandType || (StreamingCommandType = {}));
